"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextPosition = void 0;
var TextPosition;
(function (TextPosition) {
    TextPosition["CENTER"] = "center";
    TextPosition["LEFT"] = "bottom-left";
})(TextPosition = exports.TextPosition || (exports.TextPosition = {}));
